export const categoriesComparerFactory = (secondarySorting) => (a, b) => (a.sortIndex ?? Number.MAX_SAFE_INTEGER) - (b.sortIndex ?? Number.MAX_SAFE_INTEGER) || a[secondarySorting].localeCompare(b[secondarySorting])
export const defaultCategoriesComparer = categoriesComparerFactory('TechnicalName')
